import { createContext, useContext } from "react";

import { AppointmentTypeScreenModel } from "./AppointmentTypeScreenModel.ts";

export const AppointmentTypeScreenContext =
  createContext<AppointmentTypeScreenModel>({} as AppointmentTypeScreenModel);

export const useAppointmentTypeScreenContext = () =>
  useContext(AppointmentTypeScreenContext);
